import React from "react";
import { useSelector } from "react-redux";
import { Card, Row, Col } from "react-bootstrap";
import {
  LuSend, LuCircleCheck, LuClock, LuCircleX
} from "react-icons/lu";
import { formatCurrency } from "../../../utils/currency";

export default function InvoiceInsights() {
  const { analytics } = useSelector((state) => state.invoice);
  const currency = useSelector((state) => state.business?.currencyContext?.currency || 'CAD');
  const stats = analytics?.invoiceStats || {};

  const cards = [
    {
      label: "Total Sent",
      amount: stats?.totalsent?.amount || 0,
      count: stats?.totalsent?.number || 0,
      icon: <LuSend size={16} />,
      color: "#28B0C4",
      bg: "#e8f8fb",
    },
    {
      label: "Total Paid",
      amount: stats?.totalpaid?.amount || 0,
      count: stats?.totalpaid?.number || 0,
      icon: <LuCircleCheck size={16} />,
      color: "#10b981",
      bg: "#d1fae5",
    },
    {
      label: "Total Unpaid",
      amount: stats?.totalunpaid?.amount || 0,
      count: stats?.totalunpaid?.number || 0,
      icon: <LuClock size={16} />,
      color: "#f59e0b",
      bg: "#fef3c7",
    },
    {
      label: "Total Cancelled",
      amount: stats?.totalcanceled?.amount || 0,
      count: stats?.totalcanceled?.number || 0,
      icon: <LuCircleX size={16} />,
      color: "#ef4444",
      bg: "#fee2e2",
    },
  ];

  return (
    <Row className="g-3 mb-4">
      {cards.map((card) => (
        <Col key={card.label} xs={12} sm={6} xl={3}>
          <Card className="border-0 shadow-sm rounded-4 px-3 py-3 h-100">
            <div className="d-flex align-items-center justify-content-between">
              <div>
                <div className="text-muted small fw-medium mb-1">{card.label}</div>
                <div className="fw-bold fs-6">{formatCurrency(card.amount, currency)}</div>
              </div>
              <div
                className="rounded-3 d-flex align-items-center justify-content-center"
                style={{ width: 36, height: 36, background: card.bg, color: card.color }}
              >
                {card.icon}
              </div>
            </div>
            <div className="mt-2 pt-2 border-top d-flex align-items-center gap-1">
              <span className="fw-bold small" style={{ color: card.color }}>
                {card.count}
              </span>
              <span className="text-muted small">invoices</span>
            </div>
          </Card>
        </Col>
      ))}
    </Row>
  );
}